export const categories = [
  {
    slug: 'premium-residence',
    name: '精品居住',
    description: '汇集城市核心地段高端住宅资源，从独栋别墅到顶层复式，每一处居所皆为匠心甄选。',
    icon: 'ri-building-2-line',
    imageSeq: 'cat-residence',
    articleCount: 24,
  },
  {
    slug: 'quality-service',
    name: '优质服务',
    description: '专属管家、私人定制、尊享礼遇，为您提供超越期待的品质生活服务体系。',
    icon: 'ri-vip-crown-line',
    imageSeq: 'cat-service',
    articleCount: 18,
  },
  {
    slug: 'member-privilege',
    name: '会员权益',
    description: '精品八区会员独享特权，涵盖高端社交、定制旅行、艺术品鉴赏等专属权益。',
    icon: 'ri-medal-line',
    imageSeq: 'cat-member',
    articleCount: 15,
  },
  {
    slug: 'lifestyle-guide',
    name: '生活指南',
    description: '高品质生活方式指南，从家居美学到健康管理，全方位提升生活质感。',
    icon: 'ri-book-open-line',
    imageSeq: 'cat-lifestyle',
    articleCount: 21,
  },
  {
    slug: 'community-event',
    name: '社区活动',
    description: '精品八区定期举办高端社交活动，名流雅集，私享盛宴，拓展精英人脉圈层。',
    icon: 'ri-calendar-event-line',
    imageSeq: 'cat-event',
    articleCount: 12,
  },
  {
    slug: 'investment-insight',
    name: '投资洞察',
    description: '深度剖析高端地产与优质资产投资趋势，为会员提供专业投资决策参考。',
    icon: 'ri-line-chart-line',
    imageSeq: 'cat-invest',
    articleCount: 16,
  },
];

export const articles = [
  {
    slug: 'city-center-villa-guide',
    title: '城市中心独栋别墅选购指南：地段、品质与升值潜力全解析',
    excerpt: '在寸土寸金的城市核心区域选择独栋别墅，需要综合考量地段价值、建筑品质、园林设计以及未来升值空间等多重因素。本文为您深度解析城市中心别墅的选购要点。',
    category: 'premium-residence',
    categoryName: '精品居住',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20luxury%20villa%20exterior%20with%20glass%20walls%20and%20green%20garden%2C%20warm%20sunset%20lighting%2C%20sophisticated%20architecture%2C%20clean%20lines%2C%20premium%20lifestyle&width=1200&height=675&seq=article-villa-guide&orientation=landscape',
    author: '精品八区编辑部',
    publishDate: '2026-07-28',
    readTime: '8分钟',
    content: [
      { type: 'heading', text: '城市中心别墅的价值核心' },
      { type: 'paragraph', text: '城市中心的独栋别墅，代表的不仅是一种居住形态，更是一种稀缺资源的占有。在全球一线城市，核心地段的别墅产品因其不可复制的地段优势和有限的供应量，始终保持着强劲的资产保值增值能力。精品八区深入调研北京、上海、深圳等核心城市的高端别墅市场，为您呈现最全面的选购指南。' },
      { type: 'heading', text: '地段选择：三大核心要素' },
      { type: 'paragraph', text: '地段是决定别墅价值的第一要素。优质的市中心别墅地段通常具备以下特征：首先，交通便利性——与城市核心商圈、国际机场、高铁站的距离控制在30分钟车程以内；其次，配套成熟度——周边拥有国际学校、顶级医疗机构、高端商业综合体等完善配套；第三，环境私密性——虽处闹市却能独享一方宁静，这是市中心别墅最珍贵的品质。' },
      { type: 'heading', text: '建筑品质：细节决定高度' },
      { type: 'paragraph', text: '高端别墅的建筑品质体现在多个维度。从外立面的石材选材、门窗系统的隔热隔音性能，到室内空间的层高设计、动线规划，每一个细节都关乎居住体验。精品八区建议购房者重点关注：建筑结构的抗震等级、外墙保温系统的效能、以及智能家居系统的集成度。这些"看不见"的品质，往往决定了长期居住的舒适度。' },
      { type: 'heading', text: '园林景观：城市中的自然绿洲' },
      { type: 'paragraph', text: '在寸土寸金的市中心，拥有私家园林是别墅最奢侈的配置。优秀的园林设计应当实现"步移景异"的空间体验，将中式园林的意境与西式园林的功能性相结合。精品八区特别推荐关注植物的四季变化设计——春季繁花似锦，夏季绿荫如盖，秋季红叶层染，冬季枝干虬劲，让园林成为一幅随时间流转的立体画卷。' },
      { type: 'heading', text: '投资前景与升值潜力' },
      { type: 'paragraph', text: '从长期投资视角来看，城市中心别墅具有极强的抗风险能力和稳健的升值表现。近五年数据显示，一线城市核心区独栋别墅的年均升值率保持在8%-15%之间，远超普通住宅。随着城市化进程的深入和核心区土地供应的日趋紧张，这一趋势预计将持续强化。精品八区建议投资者重点关注城市更新重点区域和政策利好板块，这些区域的别墅产品往往具有更高的价值增长空间。' },
    ],
    tags: ['别墅选购', '城市中心', '高端住宅', '投资指南'],
  },
  {
    slug: 'butler-service-experience',
    title: '专属管家服务的正确打开方式：从日常起居到尊享礼遇',
    excerpt: '真正的管家服务远不止于日常琐事的打理，它是一套完整的品质生活解决方案。精品八区为您揭秘高端管家服务的核心价值与实际体验。',
    category: 'quality-service',
    categoryName: '优质服务',
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20butler%20in%20luxury%20hotel%20lobby%2C%20elegant%20uniform%2C%20warm%20lighting%2C%20marble%20interior%2C%20sophisticated%20atmosphere%2C%20high-end%20service&width=1200&height=675&seq=article-butler&orientation=landscape',
    author: '精品八区服务部',
    publishDate: '2026-07-25',
    readTime: '6分钟',
    content: [
      { type: 'heading', text: '管家服务的本质：超越期待的生活方式管理' },
      { type: 'paragraph', text: '在精品八区，我们理解的管家服务绝非简单的家政管理。真正的管家，是您生活方式的守护者和品质的保障者。从清晨的第一杯手冲咖啡，到深夜归家时已调至舒适温度的室内环境，管家用无微不至的细节关怀，为会员打造无缝衔接的尊享生活体验。' },
      { type: 'heading', text: '日常起居的全方位呵护' },
      { type: 'paragraph', text: '精品八区管家团队为会员提供365天全天候服务。每日清晨，管家会根据天气预报为您准备当日穿搭建议；根据您的健康档案和饮食偏好，与私人厨师协同制定每周膳食计划；定期检查住宅的空调新风系统、泳池水质、园林养护状态，确保居住环境始终处于最佳状态。这一切，都在您看不见的地方悄然发生。' },
      { type: 'heading', text: '定制化尊享服务矩阵' },
      { type: 'paragraph', text: '在基础服务之上，精品八区为会员打造了丰富的定制化服务矩阵。需要为重要商务伙伴安排一场私密晚宴？管家可在24小时内协调米其林星级厨师、专业侍酒师和现场弦乐四重奏。计划一次说走就走的海外旅行？管家团队负责从私人飞机调度、目的地顶级酒店预订到当地资深向导对接的全流程服务。' },
      { type: 'heading', text: '服务品质的保障体系' },
      { type: 'paragraph', text: '精品八区管家团队的选拔标准极为严苛。每位管家均需通过背景调查、专业能力测试、礼仪考核及心理评估四重筛选，录取率不足3%。入职后还需完成为期三个月的系统培训，涵盖高端家政管理、危机处理、跨文化沟通等专业课程。我们为每位管家配备专属督导，确保服务品质始终如一。' },
    ],
    tags: ['管家服务', '品质生活', '尊享体验', '定制服务'],
  },
  {
    slug: 'member-social-circle',
    title: '精英圈层社交指南：如何在精品八区构建高价值人脉网络',
    excerpt: '精品八区汇聚了来自各行业的精英人士。了解如何在社区中有效社交，将帮助您拓展高价值人脉，创造更多事业与生活的可能性。',
    category: 'member-privilege',
    categoryName: '会员权益',
    coverImage: 'https://readdy.ai/api/search-image?query=Upscale%20social%20networking%20event%20in%20elegant%20lounge%2C%20well-dressed%20professionals%2C%20warm%20ambient%20lighting%2C%20luxury%20interior%2C%20sophisticated%20gathering&width=1200&height=675&seq=article-social&orientation=landscape',
    author: '精品八区社区部',
    publishDate: '2026-07-22',
    readTime: '7分钟',
    content: [
      { type: 'heading', text: '精品八区：不止于居住，更是圈层的选择' },
      { type: 'paragraph', text: '选择精品八区，意味着您选择进入了一个由各领域精英构成的优质社交圈。在这里，您的邻居可能是科技公司的创始人、知名艺术家、顶级投资人或是资深学者。精品八区通过精心设计的社交活动和服务体系，为会员创造自然而高效的社交场景。' },
      { type: 'heading', text: '社区活动的社交价值' },
      { type: 'paragraph', text: '精品八区每月举办2-3场高品质社交活动，涵盖艺术品鉴、投资沙龙、健康讲座、美食美酒品鉴等多元主题。这些活动采用"小规模、高互动"的模式，每场活动参与人数控制在20-30人，确保每位会员都有充分交流的机会。我们的活动策划团队会根据参与者的背景和兴趣进行精准匹配，让每一次社交都富有成效。' },
      { type: 'heading', text: '共享空间的社交场景' },
      { type: 'paragraph', text: '精品八区会所内的红酒雪茄吧、茶室、恒温泳池、健身房等共享空间，为会员提供了日常轻松社交的绝佳场所。我们特别设计的空间布局兼顾了私密性和开放性——您可以在红酒雪茄吧的壁炉旁与新朋友畅谈，也可以在茶室的包厢内进行深度商务洽谈。' },
      { type: 'heading', text: '商务对接与资源整合' },
      { type: 'paragraph', text: '精品八区为会员提供专属的商务对接服务。当您有特定的合作需求时，我们的社区经理会根据会员数据库为您精准匹配潜在合作伙伴，并在双方同意的前提下促成对接。过去一年中，通过精品八区平台达成的商业合作金额已超过50亿元，涵盖地产、科技、文化、金融等多个领域。' },
    ],
    tags: ['精英社交', '圈层文化', '人脉拓展', '会员权益'],
  },
  {
    slug: 'home-aesthetics-2026',
    title: '2026年高端家居美学趋势：极简之上的温度与质感',
    excerpt: '高端家居设计正从冰冷的极简主义转向有温度的质感美学。精品八区邀请知名室内设计师，为您解读2026年最前沿的高端家居设计趋势。',
    category: 'lifestyle-guide',
    categoryName: '生活指南',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20luxury%20living%20room%20interior%20with%20natural%20stone%20textures%2C%20wood%20elements%2C%20soft%20ambient%20lighting%2C%20terracotta%20accents%2C%20elegant%20modern%20design&width=1200&height=675&seq=article-aesthetics&orientation=landscape',
    author: '精品八区编辑部',
    publishDate: '2026-07-20',
    readTime: '5分钟',
    content: [
      { type: 'heading', text: '从极简到质感：2026年设计风向标' },
      { type: 'paragraph', text: '经历了长达十年的极简主义风潮后，2026年的高端家居设计正在发生令人欣喜的转变——设计师们不再追求"少即是多"的冰冷克制，转而拥抱充满温度与个性的质感美学。天然石材的纹理、手工织物的触感、定制木作的温润，这些元素正成为高端住宅空间的主角。' },
      { type: 'heading', text: '天然材料的回归与创新' },
      { type: 'paragraph', text: '2026年最显著的趋势是天然材料的强势回归。意大利卡拉拉大理石、缅甸柚木、手工锻造的黄铜件，这些材料以其独特的纹理和质感，为空间注入不可复制的个性。与此同时，新型环保材料也在崛起——回收玻璃制成的水磨石台面、竹纤维编制的壁布、可降解的生物基材料，在环保与美学之间找到了完美平衡。' },
      { type: 'heading', text: '色彩的温暖革命' },
      { type: 'paragraph', text: '2026年的色彩趋势告别了冷淡的白灰基调，转向更加温暖的色系。焦糖色、陶土色、橄榄绿、深蓝灰成为主流。设计师们善于将这些色彩以"色块"的方式融入空间——一面陶土色的艺术涂料墙面、一组焦糖色天鹅绒沙发、几件橄榄绿的手工陶瓷摆件，用克制的色彩点缀营造丰富的层次感。' },
      { type: 'heading', text: '智能与人文的共生' },
      { type: 'paragraph', text: '高端家居的智能化已不再是炫技式的科技堆砌，而是追求"无感智能"——技术在后台默默运转，为居住者提供恰到好处的服务。智能照明系统根据自然光变化自动调节色温与亮度，新风系统实时监测空气质量并自动调整，背景音乐系统根据时间和场景智能切换播放列表。科技隐于无形，人文关怀触手可及。' },
    ],
    tags: ['家居美学', '设计趋势', '高端装修', '生活方式'],
  },
  {
    slug: 'wine-tasting-gala',
    title: '精品八区·名庄之夜：波尔多列级名庄品鉴会精彩回顾',
    excerpt: '精品八区联合法国波尔多五大名庄，为会员呈现了一场顶级的葡萄酒品鉴盛宴。从拉菲到玛歌，从1982到2018，一场穿越时空的味觉之旅。',
    category: 'community-event',
    categoryName: '社区活动',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20wine%20tasting%20event%20with%20fine%20wine%20bottles%20on%20dark%20wood%20table%2C%20warm%20candlelight%2C%20luxury%20dining%20setting%2C%20sophisticated%20atmosphere&width=1200&height=675&seq=article-wine&orientation=landscape',
    author: '精品八区活动部',
    publishDate: '2026-07-18',
    readTime: '4分钟',
    content: [
      { type: 'heading', text: '一场顶级的味觉盛宴' },
      { type: 'paragraph', text: '2026年7月15日晚，精品八区"名庄之夜"波尔多列级名庄品鉴会在北京国贸大酒店盛大举行。本次活动特邀法国波尔多葡萄酒协会认证侍酒师Pierre Dubois先生担任首席品鉴师，为到场的60余位会员带来了一场穿越半个世纪的味觉之旅。' },
      { type: 'heading', text: '精选酒单：跨越时空的佳酿' },
      { type: 'paragraph', text: '本次品鉴会精选了来自波尔多五大名庄的12款经典年份佳酿。从1982年拉菲的传奇韵味，到2000年玛歌的优雅绽放，再到2018年木桐的艺术酒标，每一款酒都承载着独特的历史与故事。特别值得一提的是，我们还为会员准备了一款1970年的滴金贵腐甜白作为收官之酒，其琥珀色的酒液和蜂蜜般的余韵令在场所有人赞叹不已。' },
      { type: 'heading', text: '不止于品鉴：沉浸式文化体验' },
      { type: 'paragraph', text: '我们深知，高端品鉴会的价值远不止于味觉享受。本次活动特别设计了"盲品挑战"、"名庄故事会"和"藏酒交流"三个互动环节。在盲品挑战中，会员们凭借敏锐的嗅觉和味觉辨别酒款的产区与年份；在名庄故事会上，Pierre Dubois先生娓娓道来每座名庄的百年传奇。' },
      { type: 'heading', text: '下期活动预告' },
      { type: 'paragraph', text: '延续"名庄之夜"的成功，精品八区计划于9月推出"舌尖上的意大利"主题品鉴晚宴，届时将邀请意大利顶级米其林三星主厨与侍酒师联袂呈现。敬请各位会员关注活动通知，名额有限，先到先得。' },
    ],
    tags: ['品鉴会', '名庄红酒', '会员活动', '社交盛宴'],
  },
  {
    slug: 'luxury-real-estate-2026',
    title: '2026下半年高端地产投资前瞻：政策拐点下的价值重估',
    excerpt: '随着宏观政策环境的变化，高端地产市场正迎来新一轮价值重估。精品八区投资研究团队为您深度解读2026下半年的投资机遇与策略。',
    category: 'investment-insight',
    categoryName: '投资洞察',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20with%20luxury%20high-rise%20buildings%2C%20golden%20sunset%2C%20sophisticated%20urban%20atmosphere%2C%20premium%20real%20estate%2C%20financial%20district&width=1200&height=675&seq=article-invest&orientation=landscape',
    author: '精品八区投资研究部',
    publishDate: '2026-07-15',
    readTime: '9分钟',
    content: [
      { type: 'heading', text: '宏观背景：政策拐点已至' },
      { type: 'paragraph', text: '2026年上半年，一系列稳地产、促消费的政策信号密集释放。央行连续两次降准释放流动性，多地放松高端住宅限购政策，公积金贷款额度大幅提升。在政策组合拳的作用下，高端地产市场率先回暖。精品八区投资研究团队认为，当前正处于政策红利释放的关键窗口期。' },
      { type: 'heading', text: '一线城市：核心资产价值回归' },
      { type: 'paragraph', text: '北京、上海、深圳的核心区高端住宅市场展现出强劲的复苏势头。数据显示，2026年第二季度一线城市总价3000万以上住宅成交量环比增长35%，成交均价环比上涨8%。尤其值得关注的是，具有稀缺景观资源（江景、湖景、公园景）的顶级豪宅项目，其抗跌性和升值潜力明显优于普通高端住宅。' },
      { type: 'heading', text: '新兴热点：新一线城市的崛起' },
      { type: 'paragraph', text: '除传统一线城市外，成都、杭州、南京、苏州等新一线城市的高端地产市场正成为新的投资热土。这些城市在产业升级、人才引进和城市更新方面持续发力，催生了大量高净值人群的居住需求。精品八区特别看好杭州钱江新城、成都金融城、苏州工业园区三大板块的高端住宅投资价值。' },
      { type: 'heading', text: '投资策略建议' },
      { type: 'paragraph', text: '基于当前市场环境，精品八区投资研究部为会员提出以下策略建议：第一，优先配置一线城市核心区的稀缺资产，作为资产组合的"压舱石"；第二，适当布局新一线城市潜力板块，把握城市发展红利；第三，关注城市更新和旧改项目中的高端住宅产品，这类项目往往具有更高的性价比和升值空间；第四，对于海外资产配置需求，可以关注新加坡、东京、伦敦等国际一线城市的优质住宅资产。' },
    ],
    tags: ['地产投资', '市场分析', '投资策略', '资产配置'],
  },
  {
    slug: 'private-chef-guide',
    title: '私人厨师服务完全手册：从需求评估到长期合作',
    excerpt: '聘请一位优秀的私人厨师是提升生活品质的重要一步。精品八区为您提供从需求评估、面试筛选到长期合作管理的完整指南。',
    category: 'quality-service',
    categoryName: '优质服务',
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20chef%20in%20white%20uniform%20preparing%20gourmet%20dish%20in%20luxury%20modern%20kitchen%2C%20warm%20lighting%2C%20marble%20countertop%2C%20sophisticated%20cooking%20scene&width=1200&height=675&seq=article-chef&orientation=landscape',
    author: '精品八区服务部',
    publishDate: '2026-07-12',
    readTime: '6分钟',
    content: [
      { type: 'heading', text: '私人厨师：品质生活的味觉守护者' },
      { type: 'paragraph', text: '对于追求精致生活的家庭而言，一位优秀的私人厨师的价值远超一日三餐的准备。他/她是家庭健康的守护者、宴请宾客的幕后功臣，更是一种生活方式的体现。精品八区服务团队累计为超过200个会员家庭成功匹配了私人厨师，积累了丰富的选聘与管理经验。' },
      { type: 'heading', text: '第一步：明确需求画像' },
      { type: 'paragraph', text: '在开始寻找私人厨师之前，首先需要明确家庭的实际需求：菜系偏好（中餐、西餐、日料或融合菜）、用餐人数与频率、是否需要营养管理功能（如糖尿病饮食、儿童营养餐）、接待宴请的频率和规格等。精品八区服务顾问会与您进行深入沟通，绘制出精准的需求画像。' },
      { type: 'heading', text: '第二步：专业筛选与面试' },
      { type: 'paragraph', text: '精品八区建立了严格的厨师筛选体系。每位候选人需具备：五星级酒店或高端私人会所3年以上工作经验、食品卫生安全证书、至少2项菜系专长。面试环节我们建议采用"理论+实操"双轨考核——先进行菜品设计与食材采购理念的交流，再安排一次试餐，由家人共同品评。' },
      { type: 'heading', text: '第三步：合约与长期管理' },
      { type: 'paragraph', text: '正式合作前，建议签订详细的服务协议，明确工作内容、工作时间、薪资结构、保密条款等关键事项。在长期管理中，建立定期的菜品沟通机制和季度绩效回顾非常重要。精品八区为会员提供持续的厨师督导与培训支持，确保服务质量稳定在最高水准。' },
    ],
    tags: ['私人厨师', '品质餐饮', '家庭服务', '生活指南'],
  },
  {
    slug: 'art-collection-beginner',
    title: '艺术品收藏入门：从第一件藏品到构建个人收藏体系',
    excerpt: '艺术品收藏不仅是财富的配置方式，更是审美品位的表达。精品八区联合资深艺术顾问，为初入收藏领域的会员提供专业入门指南。',
    category: 'member-privilege',
    categoryName: '会员权益',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20art%20gallery%20interior%20with%20modern%20paintings%20on%20walls%2C%20warm%20spotlight%2C%20wooden%20floor%2C%20sophisticated%20cultural%20atmosphere%2C%20minimalist%20design&width=1200&height=675&seq=article-art&orientation=landscape',
    author: '精品八区文化部',
    publishDate: '2026-07-10',
    readTime: '8分钟',
    content: [
      { type: 'heading', text: '收藏的起点：建立审美判断力' },
      { type: 'paragraph', text: '艺术品收藏之旅始于审美判断力的培养。多看、多感受、多学习是必经之路。精品八区建议会员从参观顶级美术馆、阅读权威艺术评论、参与艺术讲座入手，逐步建立自己的审美标准和价值判断。不要急于出手购买，先用一年的时间"养眼"，让眼睛习惯最好的作品。' },
      { type: 'heading', text: '入门收藏的四个方向' },
      { type: 'paragraph', text: '对于初入收藏领域的会员，精品八区推荐四个相对稳妥的入门方向：第一，现当代版画——门槛适中，真伪鉴定相对容易，市场流动性好；第二，青年艺术家原作——发现潜力股，享受与艺术家共同成长的乐趣；第三，古董文房器物——兼具实用性与收藏价值，文化内涵丰富；第四，限量艺术衍生品——知名艺术家授权的小型雕塑或装置，装饰性与收藏性兼具。' },
      { type: 'heading', text: '构建收藏体系的逻辑' },
      { type: 'paragraph', text: '有经验的收藏者不会随意购买，而是围绕明确的主题构建收藏体系。可以是某个艺术流派的发展脉络（如从印象派到后印象派的演变），也可以是某个题材的多维呈现（如"山水"主题在国画、油画、摄影中的不同表达）。精品八区艺术顾问团队可以为会员提供个性化的收藏体系规划服务。' },
      { type: 'heading', text: '精品八区会员专属艺术服务' },
      { type: 'paragraph', text: '精品八区为会员提供一系列专属艺术服务：全球顶级拍卖行VIP预展通道、私人艺术导览、收藏品保管与保险咨询、艺术品估值与鉴定对接。此外，我们每季度组织一次"艺术私享会"，邀请知名艺术家、策展人与会员进行小范围的深度交流。' },
    ],
    tags: ['艺术品收藏', '审美培养', '收藏指南', '会员权益'],
  },
];

export const testimonials = [
  {
    name: '陈先生',
    title: '科技公司创始人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20confident%20middle-aged%20Asian%20man%20in%20a%20dark%20suit%20with%20warm%20expression%2C%20neutral%20studio%20background%2C%20clean%20and%20polished%20portrait&width=128&height=128&seq=avatar-chen&orientation=squarish',
    quote: '入住精品八区三年了，这里不仅提供了极致的居住体验，更让我结识了许多志同道合的朋友。管家团队的用心服务让我真正感受到了"家"的温度。',
    rating: 5,
  },
  {
    name: '李女士',
    title: '知名艺术家',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20professional%20headshot%20of%20a%20graceful%20Asian%20woman%20with%20artistic%20style%2C%20soft%20smile%2C%20neutral%20studio%20portrait%20with%20warm%20lighting&width=128&height=128&seq=avatar-li&orientation=squarish',
    quote: '精品八区的社区氛围让我感到非常舒适。这里定期举办的艺术沙龙和品鉴活动，为我的创作带来了许多灵感。社区对艺术文化的重视程度超出了我的预期。',
    rating: 5,
  },
  {
    name: '王先生',
    title: '投资机构合伙人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20sharp%20Asian%20man%20in%20a%20tailored%20blazer%2C%20confident%20expression%2C%20clean%20studio%20background%2C%20warm%20and%20approachable&width=128&height=128&seq=avatar-wang&orientation=squarish',
    quote: '作为投资从业者，精品八区最吸引我的是它的资源整合能力。通过社区平台促成的几笔合作都取得了不错的成果。精品八区不只是一个社区，更是一个高价值的商业生态。',
    rating: 5,
  },
  {
    name: '张女士',
    title: '企业高管',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20sophisticated%20Asian%20woman%20in%20business%20attire%2C%20warm%20confident%20smile%2C%20studio%20portrait%20with%20clean%20background&width=128&height=128&seq=avatar-zhang&orientation=squarish',
    quote: '繁忙的工作之余，精品八区是我和家人放松身心的港湾。管家团队对细节的关注令人感动——从孩子的生日派对到父母的健康管理，每一个需求都被精心照顾。',
    rating: 5,
  },
  {
    name: '刘先生',
    title: '金融行业资深专家',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20distinguished%20Asian%20man%20with%20silver%20hair%2C%20kind%20eyes%2C%20dark%20suit%2C%20clean%20studio%20portrait%20with%20soft%20lighting&width=128&height=128&seq=avatar-liu&orientation=squarish',
    quote: '精品八区的投资沙龙质量非常高，每次都能学到新的东西。社区汇聚了各行各业的精英，思想的碰撞总能擦出火花。这里是我退休后保持思维活力的重要场所。',
    rating: 5,
  },
];

export const faqItems = [
  {
    question: '如何成为精品八区会员？',
    answer: '成为精品八区会员需要通过申请与审核流程。您可以访问我们的官网提交入会申请表，我们的会员服务团队将在3个工作日内与您联系，安排一对一咨询。审核通过后，您需要缴纳相应的会员年费，即可享受精品八区的全部会员权益。',
  },
  {
    question: '精品八区会员年费是多少？包含哪些权益？',
    answer: '精品八区提供银卡、金卡和钻石卡三个会员等级，年费从8.8万元至38.8万元不等。基础权益包括：管家服务、社区活动参与、共享空间使用权、专属礼遇等。更高级别的会员还享有私人定制服务、全球高端资源对接、专属投资顾问等增值权益。具体详情请咨询我们的会员服务团队。',
  },
  {
    question: '精品八区的社区覆盖哪些城市？',
    answer: '目前精品八区已在北京、上海、深圳、杭州、成都五个城市设立了精品社区，并在三亚、厦门、昆明设有度假型物业。我们计划在未来两年内将服务网络扩展至广州、南京、苏州、武汉等城市。异地会员可享受跨城市的会所使用权和管家对接服务。',
  },
  {
    question: '管家服务的具体内容是什么？',
    answer: '精品八区的管家服务涵盖日常生活的方方面面：住宅管理（保洁维护、设备巡检、园林养护）、生活服务（餐饮定制、出行安排、健康管理）、商务支持（会务接待、行程规划、商务对接）以及个性化定制服务（私人派对策划、艺术品鉴赏安排、专属旅行定制等）。管家团队7×24小时待命，确保您的每一个需求都能得到及时响应。',
  },
  {
    question: '非会员可以参观精品八区吗？',
    answer: '我们欢迎对精品八区感兴趣的朋友预约参观。您可以致电我们的客服热线或通过官网提交预约申请，我们的接待团队将为您安排专属的参观体验。参观过程中，您将有机会深入了解社区环境、服务体系以及会员权益，并与我们的社区经理进行面对面交流。',
  },
  {
    question: '精品八区的社区活动多久举办一次？',
    answer: '精品八区每月定期举办2-3场高品质社区活动，涵盖文化艺术、投资理财、健康养生、美食美酒等多个主题。此外，每逢重要节日（春节、中秋、圣诞等），我们还会举办大型的社区庆典活动。会员可通过官方APP或社区公告提前了解活动详情并进行报名。',
  },
  {
    question: '是否可以随时退会？',
    answer: '精品八区尊重会员的自由选择权。如您因个人原因需要退会，可提前30天向会员服务部提交书面申请。我们将按比例退还未使用的会员费，并为您办理退会手续。我们始终致力于为每一位会员提供超出期待的服务体验，让您不愿离开这个温暖的高品质社区。',
  },
  {
    question: '精品八区的住宅安全如何保障？',
    answer: '安全是精品八区最核心的基础保障。我们采用国际领先的多层安防体系：24小时智能监控、人脸识别门禁、AI异常行为检测、专业安保团队巡逻。同时，所有管家和工作人员均经过严格的背景审查和保密培训，签署保密协议，确保会员隐私得到最高级别的保护。',
  },
];

export const services = [
  {
    icon: 'ri-home-heart-line',
    title: '精品居住管理',
    description: '从选房、装修到日常维护，专业团队为您提供全生命周期的居住管理服务，让您的居所始终处于最佳状态。',
  },
  {
    icon: 'ri-user-star-line',
    title: '私人管家服务',
    description: '经过严格筛选与专业培训的管家团队，为您提供全天候、个性化的高品质生活管理服务。',
  },
  {
    icon: 'ri-global-line',
    title: '全球资源对接',
    description: '依托广泛的全球合作网络，为会员链接顶级医疗、教育、艺术、商务资源，拓展生活的无限可能。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全保障体系',
    description: '智能安防 + 人工巡逻 + 隐私保护三重安全保障，为您和家人打造最安心的居住环境。',
  },
  {
    icon: 'ri-community-line',
    title: '精英社交平台',
    description: '定期举办高端社交活动与主题沙龙，为会员创造自然高效的人脉拓展与商务对接场景。',
  },
  {
    icon: 'ri-funds-line',
    title: '专属投资顾问',
    description: '资深投资顾问团队为会员提供个性化资产配置建议，助您把握市场机遇，实现财富稳健增长。',
  },
];

export const highlights = [
  {
    value: '500+',
    label: '尊贵会员',
    description: '覆盖全国核心城市',
  },
  {
    value: '98.6%',
    label: '满意度',
    description: '会员服务评价',
  },
  {
    value: '8年',
    label: '行业深耕',
    description: '持续引领品质生活',
  },
  {
    value: '5城',
    label: '核心布局',
    description: '辐射全国经济中心',
  },
];